module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cpo-header"
  }, [_c('div', {
    staticClass: "cpo-header--root"
  }, [_c('span', {
    staticClass: "cpo-header--headline",
    domProps: {
      "innerHTML": _vm._s(_vm.content.headline)
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "cpo-header--hr"
  }), _vm._v(" "), _c('h1', {
    staticClass: "cpo-header--title",
    domProps: {
      "textContent": _vm._s(_vm.content.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cpo-header--badge"
  }, [_c('div', {
    staticClass: "cpo-header--badge-text",
    domProps: {
      "innerHTML": _vm._s(_vm.linebreak(_vm.content.bubble))
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f41f42e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f41f42e0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/course-progress/cpo-header/index.vue
// module id = 594
// module chunks = 7